import { render, staticRenderFns } from "./settingCleanStaffHisPopup.vue?vue&type=template&id=67e014c4&scoped=true"
import script from "./settingCleanStaffHisPopup.vue?vue&type=script&lang=js"
export * from "./settingCleanStaffHisPopup.vue?vue&type=script&lang=js"
import style0 from "./settingCleanStaffHisPopup.vue?vue&type=style&index=0&id=67e014c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e014c4",
  null
  
)

export default component.exports